import React, { useMemo, useState, useCallback } from 'react';
import axios from 'axios';
import { useMonitoramento } from '../../context/MonitoramentoContext';
import { classificarMensagem, isContingencia } from '../../utils/classificarMensagem';
import { parseServerDate } from '../../utils/serverDate';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_823 || ''}/pdv_exception`,
  auth: { username: 'Portal', password: 'Portal1163' },
});

function formatarData(dataInput) {
  return parseServerDate(dataInput).toLocaleString('pt-BR');
}

const LogContingencia = () => {
  const { pdvData, refresh } = useMonitoramento();
  const [busca, setBusca] = useState('');
  const [lidos, setLidos] = useState(() => new Set());

  const registros = useMemo(() => {
    const ocorrencias = (pdvData || [])
      .filter(r => r.cnpj !== '11111111111111')
      .filter(r => isContingencia(r.mensagem))
      .filter(r => !lidos.has(r.controle));

    const termo = busca.trim().toLowerCase();
    const filtradas = termo
      ? ocorrencias.filter(r =>
          (r.nome || '').toLowerCase().includes(termo) ||
          (r.cnpj || '').toLowerCase().includes(termo)
        )
      : ocorrencias;

    return [...filtradas].sort((a, b) => parseServerDate(b.recepcao) - parseServerDate(a.recepcao));
  }, [pdvData, busca, lidos]);

  const marcarComoLido = useCallback(async (id) => {
    setLidos((prev) => new Set(prev).add(id));
    try {
      await axiosInstance.post(`/${id}`, '');
      refresh();
    } catch (error) {
      console.error('Erro ao marcar como lido:', error);
    }
  }, [refresh]);

  const marcarTodosComoLido = useCallback(async () => {
    const ids = registros.map(r => r.controle);
    if (ids.length === 0) return;
    setLidos((prev) => {
      const novo = new Set(prev);
      ids.forEach(id => novo.add(id));
      return novo;
    });
    try {
      await Promise.allSettled(ids.map(id => axiosInstance.post(`/${id}`, '')));
      refresh();
    } catch (error) {
      console.error('Erro ao marcar todos como lido:', error);
    }
  }, [registros, refresh]);

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ maxWidth: 280 }}
          placeholder="Filtrar por cliente ou CNPJ..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />
        {busca && (
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setBusca('')}>
            Limpar ×
          </button>
        )}
        <small className="text-muted ms-auto">{registros.length} ocorrência(s)</small>
        {registros.length > 0 && (
          <button
            type="button"
            className="btn btn-sm btn-outline-success"
            onClick={marcarTodosComoLido}
          >
            &#10003; Marcar todos como lido
          </button>
        )}
      </div>

      <div className="cs-cont-log">
        {registros.length > 0 ? (
          registros.map((registro) => {
            const classificacao = classificarMensagem(registro.mensagem);
            return (
              <div key={registro.controle} className={`cs-cont-line cs-sev-${classificacao.sev}`}>
                <span className="cs-cont-time">{formatarData(registro.recepcao)}</span>
                <span className="cs-cont-cliente">{registro.nome}</span>
                <span className="cs-cont-msg" dangerouslySetInnerHTML={{ __html: registro.mensagem }} />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-success cs-cont-lido"
                  title="Marcar como lido"
                  onClick={() => marcarComoLido(registro.controle)}
                >
                  &#10003; Lido
                </button>
              </div>
            );
          })
        ) : (
          <div className="alert alert-info" role="alert">
            Nenhuma ocorrência de contingência encontrada.
          </div>
        )}
      </div>
    </div>
  );
};

export default LogContingencia;
